<template>
  <div id="app">
    <v-app id="inspire">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card v-model="show" color="#56042C">
          <v-card-title>
            <v-row>
              <v-col cols="12" align="center">
                <h3>
                  <font color="white">
                    PRODE COPA AMÉRICA 2024
                  </font>
                </h3>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" align="center">
                <v-img max-height="150" max-width="250" src="images/copaamerica.jpg"></v-img>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row dense>
              <v-col cols="6" sm="4" md="4">
                <h6>
                  <font color="white">
                    Responsable de la Carga: {{ responsable }}
                  </font>
                </h6>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-tabs background-color="#EF9A9A" dark show-arrows>
          <v-tabs-slider color="#FFEBEE"></v-tabs-slider>
          <!-- <v-tab v-for="item in items" :key="item"></v-tab> -->
          <v-tab v-for="j in 4" :key="j"> GRUPO {{ items[j - 1] }} </v-tab>
          <!-- var equipos="equipo" + item -->
          <v-tab-item v-for="item in increase" :key="item">
            <v-row>
              <v-col cols="4" md="3" sm="2" align="right">
                <v-img :src="'images/' + equipos[item].equipo1 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item].equipo1 }}
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item].goles1" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item].goles2" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="4" md="3" sm="2">
                <v-img :src="'images/' + equipos[item].equipo2 + '.jpg'" max-height="50" max-width="50"></v-img>{{
        equipos[item].equipo2 }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" sm="2" align="right">
                <v-img :src="'images/' + equipos[item + 1].equipo1 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 1].equipo1 }}
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 1].goles1" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 1].goles2" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="4" md="3" sm="2">
                <v-img :src="'images/' + equipos[item + 1].equipo2 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 1].equipo2 }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" sm="2" align="right">
                <v-img :src="'images/' + equipos[item + 2].equipo1 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 2].equipo1 }}
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 2].goles1" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 2].goles2" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="4" md="3" sm="2">
                <v-img :src="'images/' + equipos[item + 2].equipo2 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 2].equipo2 }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" sm="2" align="right">
                <v-img :src="'images/' + equipos[item + 3].equipo1 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 3].equipo1 }}
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 3].goles1" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 3].goles2" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="4" md="3" sm="2">
                <v-img :src="'images/' + equipos[item + 3].equipo2 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 3].equipo2 }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" sm="2" align="right">
                <v-img :src="'images/' + equipos[item + 4].equipo1 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 4].equipo1 }}
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 4].goles1" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 4].goles2" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="4" md="3" sm="2">
                <v-img :src="'images/' + equipos[item + 4].equipo2 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 4].equipo2 }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="3" sm="2" align="right">
                <v-img :src="'images/' + equipos[item + 5].equipo1 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 5].equipo1 }}
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 5].goles1" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="2" md="1" sm="1">
                <v-otp-input dense v-model="equipos[item + 5].goles2" length="1" type="number"></v-otp-input>
              </v-col>
              <v-col cols="4" md="3" sm="2">
                <v-img :src="'images/' + equipos[item + 5].equipo2 + '.jpg'" max-height="50" max-width="50"></v-img>
                {{ equipos[item + 5].equipo2 }}
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
        <v-card color="pink" dark tile>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click.stop="guardarprode">Guardar</v-btn>

            <v-btn color="error" @click.stop="show = false">Salir</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-app>
  </div>
</template>
<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}

.left {
  float: left;
  width: 70%;
  position: absolute;
  height: 100%;
  overflow: auto;
}

.rigth {
  float: left;
  width: 30%;
  position: relative;
  height: 100%;
  overflow: auto;
}
</style>

<script>
import axios from "../../../axios-auth";
import moment from "moment";
//import UploadService from "../../services/UploadFilesService";
import Compressor from "compressorjs";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    legajo: "",
    nomlegajo: [],
    responsable: "",
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    fecha: moment().format("DD/MM/YYYY"),
    increase: [0, 6, 12, 18],
    items: ["A", "B", "C", "D"],
    //increase: [0, 6, 12, 18, 24, 30, 36, 42],
    //items: ["A", "B", "C", "D", "E", "F", "G", "H"],
    equipos: [],
    prode: [],
    idresultados: [],
  }),
  // watch: {
  //   select: function(val) {
  //     this.cargarResultadoLegajo();
  //   },
  // },
  computed: {
    show: {
      get() {
        this.responsable = this.$store.state.nombre.toString().trim();
        this.cargarResultado();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          this.$emit("close");
        }
      },
    },
    isActive() {
      return false;
    },
  },

  methods: {
    cargarResultado() {
      let self = this;
      axios
        .get("/App/GetProdeResultados?")
        .then((response) => {
          self.equipos = response.data;
        })
        .catch((error) => {
          self.equipos = [];
          console.log(error);
        });
    },
    guardarprode() {
      this.$swal({
        title: "Guardar Resultados",
        text: "¿Desea guardar los datos?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        const headers = {
          Authorization: "Bearer my-token",
          "Content-Type": "application/json",
        };
        if (result.value) {
          this.equipos.forEach((element) => {
            if (element.goles1 != "" && element.goles1 != null) {
              this.prode.push({
                goles1: element.goles1,
                goles2: element.goles2,
                id: element.idresultado,
              });
            }
          });
          let self = this;
          axios
            .post("/App/Guardarresultado/", self.prode)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarListado();
              self.showAlert({
                icon: "success",
                title: "Resultados guardados con éxito",
                vm: self,
              });
              self.$emit("close");
            })
            .catch({});
        } else {
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 3000,
      });
    },
    vaciarListado() {
      this.prode = [];
      this.equipos = [];
    },
  },
};
</script>
